import exportacaoRepository from './exportacaoRepositoryRepository'
import procedimentoConsolidadoRepository from './procedimentoConsolidadoRepository'
import procedimentoIndividualizadoRepository from './procedimentoIndividualizadoRepository'
import relatorioInconsistenciaRepository from './relatorioInconsistenciaRepository'

export default baseUrl => {
    baseUrl = `${baseUrl}/bpa`

    return {
        exportacao: exportacaoRepository(baseUrl),
        procedimentoConsolidado: procedimentoConsolidadoRepository(baseUrl),
        procedimentoIndividualizado: procedimentoIndividualizadoRepository(baseUrl),
        relatorioInconsistencia: relatorioInconsistenciaRepository(baseUrl),
    }
}
